import QrCode2Icon from '@mui/icons-material/QrCode2';
import IconButton from '@mui/material/IconButton';
import { ReactElement, useEffect, useState } from "react";
import { Button, ButtonProps, Labeled, useResourceContext, useTranslate } from "react-admin";
import { useFormContext } from 'react-hook-form';
import QrCodeLogoInputModal from './QrCodeLogoInput/QrCodeLogoInputModal';

interface QrCodeLogoInputModalInputProps extends Omit<ButtonProps, 'children'> {
  icon: ReactElement;
  source?: string;
  buttonOnly?: boolean;
  hideLabel?: boolean;

  defaultValue?: string;
  // onSelect?: (fileManagerSelect: FileManagerSelect) => void;
}

const QrCodeLogoInput = ({ defaultValue, ...props }: QrCodeLogoInputModalInputProps) => {
  const { label = 'ra.action.qr_code_generator', icon, source, buttonOnly, hideLabel } = props;
  const translate = useTranslate();
  const [showDialog, setShowDialog] = useState(false);
  const resource = useResourceContext();
  const formContext = useFormContext();
  const { setValue, } = formContext ? formContext : { setValue: (_n: string, _v: any) => { } };

  const onClick = () => {
    setShowDialog(true);
  }

  const handleCloseClick = () => {
    setShowDialog(false);
  }

  return (
    <>
      {!buttonOnly
        ? !hideLabel
          ? <Labeled label={translate(`resources.${resource}.fields.${source}`)}>
            <Button label={translate(label)} onClick={onClick} {...props}>{icon}</Button>
          </Labeled>
          : <Button label={translate(label)} onClick={onClick} {...props}>{icon}</Button>
        : <IconButton title={translate(label)} onClick={onClick}>{icon}</IconButton>
      }
      <QrCodeLogoInputModal showDialog={showDialog} handleCloseClick={handleCloseClick} defaultValue={defaultValue}></QrCodeLogoInputModal>
    </>
  );
}

QrCodeLogoInput.defaultProps = {
  icon: <QrCode2Icon />,
}

export default QrCodeLogoInput;
